import dayjs from 'dayjs';

export function resolveDashboardRange(range, preset, autoUpdate, now = dayjs()) {
  const start = range?.start || now.subtract(1, 'day');
  const end = range?.end || now;
  if (!autoUpdate || preset === 'custom') return {start, end, shifted: false};
  return {start: now.subtract(end.diff(start, 'millisecond'), 'millisecond'), end: now, shifted: true};
}

// The picker edits dates, not times: include the full local calendar days.
export function normalizeCustomRange(range) {
  return {start: range.start?.startOf('day'), end: range.end?.endOf('day')};
}
